'use strict';

/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import './_vendors/promise-polyfill';
import './_vendors/jquery';

import './_modules/lazy-load';
import './_modules/mmenu';
import './_modules/faq-block';
import './_modules/mcusmoscrollbar';
import './_modules/buttons';
import './_modules/navpanel';
import './_modules/inview';
import './_modules/load';
import './_modules/video';
import './_modules/swiper';
import './_modules/time';
import horizontalScroll from './_modules/horizontal-scroll';
import wrapMedia from './_modules/wrap-media';
import validation from './_modules/validation';
import { mfpAjax, mfpIframe, mfpInline, mfpImage } from './_modules/magnific-popup';

// ----------------------------------------
// Public
// ----------------------------------------

if (document.querySelector('.js-gmap')) {
	require.ensure([], () => {
		require('_modules/map');
	}, 'gmap');
}

window.jQuery(document).ready(($) => {
	horizontalScroll('.wysiwyg table');
	wrapMedia('.wysiwyg iframe, .wysiwyg video');
	validation('.js-form');
	mfpAjax('.js-mfp-ajax');
	mfpIframe('.js-mfp-iframe');
	mfpInline('.js-mfp-inline')
	mfpImage('.js-mfp-image')

	$('.js-open-tride').on('click', () => {
		$('.tride-block').addClass('show')
		$('.tride-block').html('\t<div class="tride-block__close js-close-tride">×</div>\n' +
			'\t\t\t<iframe src="/tride" width="100%" height="600" loading="lazy" id="grtht" class="tride-block__iframe">\n' +
			'\t\t\tВаш браузер не поддерживает плавающие фреймы!\n' +
			'\t\t</iframe>')
	})

	$('body').on('click', '.js-close-tride', () => {
		$('.tride-block').removeClass('show')
	})

	$('.flowing-scroll').each((i, el) => {
		$(el).on( 'click', function(event){
			event.preventDefault();
			var id = $(this).attr('href');
			var	top = $(id).offset().top;
			$('body,html').animate({scrollTop: top}, 1000);
		});
	})

	if($('.main-video').length) {
		$('.main-video').trigger('play');
	}

});

if (IS_PRODUCTION) {
	require('./_modules/wezom-log');
}



// WEBPACK FOOTER //
// ./src/js/entry.js